import "./App.css";
import NavBarMain from "./components/NavBarMain";
import RouterMain from "./components/RouterMain";

function App() {
  return (
    <div>
     
   <NavBarMain />
      <RouterMain />
      
    
    </div>
  );
}

export default App;
